import { Budget } from "src/shared/models/budget.model";

export const BudgetSerializer = {
  fromJson(json: any): Budget {
    return new Budget(json);
  },

  fromJsonList(json: any[]): Budget[] {
    return json.map((item) => new Budget(item));
  },
};